<template>
  <div>
    <div class="course" v-tap="{methods:toggle}">
      <span class="arrow"></span>
      <div class="course-info">
        <span class="name">{{course.course_title}}</span>
        <span class="time">{{course.created_at }}</span>
      </div>

      <span class="absence">缺勤{{ course.absenteeism_count }}人</span>

    </div>
    <div class="users" v-show="visible">
      <ul>
        <li v-for="user in course.absence_user" :key="user.id">
          {{user.username}}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default{
    name: 'attendance-Item',
    props: {
      course: {
        type: Object
      }
    },
    data() {
      return {
        visible: false
      };
    },
    methods: {
      toggle() {
        this.visible = !this.visible;
      }
    },
    computed: {
      // date() {
      //   return new Date(this.course.created_at * 1000).Format('yyyy-MM-dd hh:mm');
      // }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .course {
    font-size: 0;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #7e581f;
    span {
      display: inline-block;
      font-size: px2rem(28);
      height: px2rem(60);
      line-height: px2rem(60);
      color: #636363;
      vertical-align: top;

      &.arrow {
        margin-top: px2rem(14);
        background: url('../assets/img/common/arrow_right_xi.png') no-repeat 0 0;
        background-size: 100% 100%;
        width: px2rem(32);
        margin-right: px2rem(24);
        height: px2rem(32);
      }
      &.absence {
        margin-right: px2rem(30);
      }
    }
    .course-info {
      height: px2rem(60);
      display: flex;
      flex-direction: row;
      flex: 1;
      .name {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .time {
        margin-right: px2rem(30);
      }
    }
  }

  .users {
    ul {
      li {
        color: #636363;
        display: block;
        padding-left: px2rem(5);
        margin-left: px2rem(70);
        font-size: px2rem(28);
        height: px2rem(54);
        line-height: px2rem(54);
        vertical-align: top;
        border-bottom: 1px solid #7e581f;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AttendanceItem.vue?3e077b5d